module.exports = __webpack_public_path__ + "img/sample_monkey.cd7334d30d73a6df9badbe72b5e1191d.svg";